<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_715_15694)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.0114 3.01766C17.7839 1.4956 15.6624 -0.109863 12.3077 -0.109863C8.95304 -0.109863 6.83146 1.4956 5.60399 3.01766C4.3936 4.5185 3.94492 6.0516 3.88028 6.2867C3.87125 6.31977 3.86462 6.34732 3.86024 6.36627L1.69421 15.6581C1.18738 17.8322 3.18899 19.8514 5.85084 19.8514H18.7645C21.4264 19.8514 23.428 17.8322 22.9212 15.6581L20.7551 6.36627C20.7507 6.34732 20.7442 6.31977 20.7351 6.2867C20.6704 6.0516 20.2218 4.5185 19.0114 3.01766Z"
        fill="currentColor"
      />
      <path
        d="M17.3557 20.7385C16.9909 21.4315 16.4322 22.1558 15.5851 22.7095C14.7022 23.2866 13.592 23.6218 12.2403 23.6218C10.8888 23.6218 9.77858 23.2866 8.89564 22.7095C8.04861 22.1558 7.48985 21.4315 7.12498 20.7385H17.3557Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_715_15694">
        <rect width="24" height="24" fill="currentColor" transform="matrix(-1 0 0 1 24 0)" />
      </clipPath>
    </defs>
  </svg>
</template>
